export default __webpack_public_path__ + "static/MultilingualSearch-577bc9cd23bb4524afe40600e8f91673.mp4";